(function () {
  "use strict";

  if (window.__OPTI_CATALOG_CONTEXT_V343_LOADED__) return;
  window.__OPTI_CATALOG_CONTEXT_V343_LOADED__ = true;

  var ENDPOINT = "https://optimus-assistant.m-allali-ams.workers.dev/";
  var STORAGE_KEY = "opti_chat_catalog_context_v1";

  function sanitize(raw) {
    raw = raw && typeof raw === "object" ? raw : {};

    var dimension = null;
    if (typeof raw.dimension === "string") {
      var normalizedDimension = raw.dimension
        .trim()
        .replace(/\s+/g, " ")
        .toUpperCase();

      if (/^\d{3}\/\d{2}\s*R\d{2}$/.test(normalizedDimension)) {
        dimension = normalizedDimension.replace(/\s*R/i, " R");
      }
    }

    var season = null;
    if (
      raw.season === "ete" ||
      raw.season === "hiver" ||
      raw.season === "4saisons"
    ) {
      season = raw.season;
    }

    var brand = null;
    if (typeof raw.brand === "string" && raw.brand.trim()) {
      brand = raw.brand.trim().slice(0, 80);
    }

    // Politique OPTI : seul le contexte commercial principal
    // persiste entre les tours. Les critères secondaires restent
    // interrogeables, mais ne deviennent jamais des filtres permanents.
    return {
      dimension: dimension,
      season: season,
      brand: brand,
    };
  }

  function hasContext(context) {
    return !!(
      context &&
      (context.dimension || context.season || context.brand)
    );
  }

  function loadContext() {
    try {
      return sanitize(
        JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}")
      );
    } catch (_) {
      return sanitize({});
    }
  }

  function saveContext(raw) {
    var context = sanitize(raw);

    try {
      if (hasContext(context)) {
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(context)
        );
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (_) {}
  }

  var nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    var url =
      typeof input === "string"
        ? input
        : input && input.url;

    if (
      !url ||
      url.indexOf(ENDPOINT) !== 0 ||
      !init ||
      String(init.method || "GET").toUpperCase() !== "POST"
    ) {
      return nativeFetch(input, init);
    }

    var payload;
    try {
      payload = JSON.parse(init.body || "{}");
    } catch (_) {
      return nativeFetch(input, init);
    }

    var context = loadContext();

    // Envoi du contexte structuré au Worker sans réécrire la question.
    // Cela évite qu'un ancien Runflat / XL / OEM / indice / promo
    // contamine la recherche suivante.
    if (hasContext(context)) {
      payload.catalogContext = context;
    } else {
      delete payload.catalogContext;
    }

    var nextInit = Object.assign({}, init, {
      body: JSON.stringify(payload),
    });

    return nativeFetch(input, nextInit).then(function (response) {
      try {
        var clone = response.clone();

        clone
          .json()
          .then(function (data) {
            if (!data || typeof data !== "object") return;

            var search =
              data.search && typeof data.search === "object"
                ? data.search
                : {};

            // Le Worker peut renvoyer le contexte au niveau racine
            // même lorsqu'il n'y a pas d'objet `search`. On le capture
            // donc en priorité au lieu d'abandonner trop tôt.
            var nextContext =
              data.catalogContext ||
              search.catalogContext ||
              search.criteria ||
              null;

            if (nextContext) {
              saveContext(nextContext);
            }
          })
          .catch(function () {});
      } catch (_) {}

      return response;
    });
  };
})();
